import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightsService {
  private appInsights;

  constructor(private router: Router) {
    if (environment.useappInsights) {
       this.appInsightConfig();
    }
  }

  appInsightConfig() {
    let angularPlugin = new AngularPlugin();
    let clickPluginInstance = new ClickAnalyticsPlugin();
    let clickPluginConfig = {
      autoCapture: true,
    };

    try {
      this.appInsights = new ApplicationInsights({
        config: {
          connectionString: environment.appInsights.connectionString,
          extensions: [<any>angularPlugin, clickPluginInstance],
          extensionConfig: {
            [angularPlugin.identifier]: { router: this.router },
            [clickPluginInstance.identifier]: clickPluginConfig,
          },
        },
      });
      this.appInsights.loadAppInsights();
      console.log("AppInsights Config - Initialized Application Insights");
    } catch (error) {
      console.error("AppInsights Config - Failed to initialize Application Insights, ", error);
    }
  }

  // log exceptions and severity
  logException(errmessage: Error, rawerror:any, internalError : any) {
    if (this.appInsights) {
      this.appInsights.trackException({
        exception: rawerror,        
        error: internalError
      });
      console.log('Log Exception - Application Insights is initialized, ');
    } else {
      console.error('Log Exception - Application Insights is not initialized, ', errmessage);
    }
  }

  // log user email via authenticated user ID property and custom userEmail property. userEmail is a custom property that is only set when the user logs in to allow for tracking of the number of users who use the application
  setUser(email: string) {
    var properties = { userEmail: email };
    if (this.appInsights) {
      this.appInsights.trackEvent({
        name: 'User Login',
        properties: properties,
      });
      this.appInsights.setAuthenticatedUserContext(email);
      console.log('Set User - Application Insights is initialized');
    } else {
      console.error('Set User - Application Insights is not initialized');
    }
  }

  // log event with user email as a property. Each individual property should have the userEmail attached to it
  logEvent(name: string, email: string, properties?: { [key: string]: any }) {
    properties = { ...properties, userEmail: email };
    if (this.appInsights) {
      this.appInsights.trackEvent({ name: name }, properties);
      console.log('Log event - Application Insights is initialized');
    } else {
      console.error('Log event - Application Insights is not initialized');
    }
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) 
  {
     this.appInsights.trackMetric({ name, average }, properties); 
  }

  logPageView(name?: string, url?: string) 
  {
     this.appInsights.trackPageView({ name, uri: url }); 
  }
}
